import React, { useEffect } from 'react';
import { useParams, Routes, Route } from 'react-router-dom';
import { Container } from '@mui/material';
import RequireAuth from 'Helpers/RequireAuth';
import ConfirmDevice from 'Components/Onboard/ConfirmDevice';
import ConfirmInstalled from 'Components/Onboard/ConfirmInstalled';
import ConfirmBuilding from './ConfirmBuilding';
import CircularLoader from 'Components/Loaders/CircularLoader';
import useGlobalState from 'Hooks/useGlobalState';
import { getDeviceByUuname } from 'Data/api';
import AddRoomTitle from './AddRoomTitle';
import AddRoomDescription from './AddRoomDescription';
import OnboardComplete from './OnboardComplete';
import FooterMenu from 'Components/FooterMenu';

const Onboard = (props) => {
	const { deviceId } = useParams();
	const [state, dispatch] = useGlobalState();
	const { onboardActive } = state;

	useEffect(() => {
		let uuname = 'skyen' + deviceId.replace('SKY', '')
		console.log('Onboard - useEffect', deviceId, uuname)
		const fetchData = async () => {
			let device = await getDeviceByUuname(uuname)
			dispatch({ device: device });
			if (device) {
				dispatch({ onboardActive: true });
			} else {
				dispatch({ onboardActive: false });
			}
		}
		fetchData();
		console.log(state.device)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (state.device ? 
		<>
		<FooterMenu onboardActive={onboardActive} />
		<Routes>
			<Route path="/installed" element={<RequireAuth><ConfirmInstalled /></RequireAuth>}></Route>
			<Route path="/building" element={<RequireAuth><ConfirmBuilding /></RequireAuth>}></Route>
			<Route path="/addroomtitle" element={<RequireAuth><AddRoomTitle /></RequireAuth>}></Route>
			<Route path="/addroomdesc" element={<RequireAuth><AddRoomDescription /></RequireAuth>}></Route>
			<Route path="/complete" element={<RequireAuth><OnboardComplete /></RequireAuth>}></Route>
			<Route path="/test" element={<Container>Hej</Container>}></Route>
			<Route path="/" element={<RequireAuth><ConfirmDevice /></RequireAuth>}></Route>
			<Route path="" element={<RequireAuth><ConfirmDevice /></RequireAuth>}></Route>
		</Routes>
		</>
		:
		<CircularLoader />
	)

}

export default Onboard;